(function () {

    "use strict";

    angular
        .module('components')
        .component('hDateRangePicker', {
            bindings: {
                disablePeriods: '<',
                rangeFrom:'<',
                rangeTo:'<',
                minDate: '<',
                maxDate: '<',
                period:'<',
                isClearEnabled: '<',
                ngDisabled: '<',
                onRangeApplied: '&',
                startDayOfWeek: '<',
                buttonText: '<'
            },
            controller: hDateRangePickerComponent,
            controllerAs: '$ctrl',
            templateUrl: '../hmodules/components/h-date-range-picker/h-date-range-picker.component.ng.html'
        });

    hDateRangePickerComponent.$inject = ['$scope'];

    function hDateRangePickerComponent($scope) {

        var self = this;

        var PERIODS = {
            TODAY: {
                key: "TODAY",
                label: $filter("translate")("Today")
            },
            THIS_MONTH: {
                key: "THIS_MONTH",
                label: $filter("translate")("This Month")
            },
            LAST_MONTH: {
                key: "LAST_MONTH",
                label: $filter("translate")("last Month")
            },
            THIS_WEEK: {
                key: "THIS_WEEK",
                label: $filter("translate")("This Week")
            },
            LAST_WEEK: {
                key: "LAST_WEEK",
                label: $filter("translate")("Last Week")
            },
            LAST_3_MONTH: {
                key: "LAST_3_MONTH",
                label: $filter("translate")("Last 3 Months")
            },
            LAST_6_MONTH: {
                key: "LAST_6_MONTH",
                label: $filter("translate")("Last 6 Months")
            },
            LAST_12_MONTH: {
                key: "LAST_12_MONTH",
                label: $filter("translate")("Last 12 Months")
            }
        };


        var isValidRangeDate = function(date){
            return date && date  instanceof moment;
        };

        var isValidPeriod = function(){
            return self.period && PERIODS[self.period.toUpperCase()];
        };

        var getSelectedDateRange = function (selectedDateRange) {
            var startDate;
            var endDate;

            var startDayOfWeekMoment = getWeekStart(moment().startOf('day'), self.startDayOfWeek || 'MON');
            switch (selectedDateRange) {
                case "TODAY" :
                    startDate = moment().locale("en").startOf('day');
                    endDate = moment().locale("en").endOf('day');
                    break;
                case "THIS_WEEK" :
                    startDate = startDayOfWeekMoment.clone().startOf('day');
                    endDate = startDate.clone().add(6, 'day').endOf('day');
                    break;
                case "LAST_WEEK" :
                    startDate = startDayOfWeekMoment.clone().subtract(7, 'day').startOf('day');
                    endDate = startDate.clone().add(6, 'day').endOf('day');
                    break;
                case "LAST_MONTH" :
                    var lastMonthDate = moment().subtract(1, "months");
                    startDate = moment([lastMonthDate.year(), lastMonthDate.month()]);
                    endDate = startDate.clone().endOf('month');
                    break;
                case "LAST_3_MONTH":
                    startDate = moment().subtract(3, "months").startOf('month');
                    endDate = startDate.clone().add(2, "months").endOf('month');
                    break;
                case "LAST_6_MONTH":
                    startDate = moment().subtract(6, "months").startOf('month');
                    endDate = startDate.clone().add(5, "months").endOf('month');
                    break;
                case "LAST_12_MONTH":
                    startDate = moment().subtract(12, "months").startOf('month');
                    endDate = startDate.clone().add(11, "months").endOf('month');
                    break;
                case "THIS_MONTH" :
                default:
                    startDate = moment().startOf('month');
                    endDate = moment().endOf('month');
                    break;
            }

            if(isValidRangeDate(self.maxDate) && startDate.isAfter(self.maxDate)) {
                startDate = self.maxDate.clone();
            }

            if(isValidRangeDate(self.maxDate) && endDate.isAfter(self.maxDate)) {
                endDate = self.maxDate.clone();
            }

            if(isValidRangeDate(self.minDate) && startDate.isBefore(self.minDate)) {
                startDate = self.minDate.clone();
            }

            if(isValidRangeDate(self.minDate) && endDate.isBefore(self.minDate)) {
                endDate = self.minDate.clone();
            }

            return {
                from: startDate,
                to: endDate
            };
        };

        var unSelectDateRanges = function(){
            self.selectedDateRange = null;
            self.dateRanges.forEach(function (dr) {
                dr.selected = false;
            })
        };

        var setRangeDates = function(rangeFrom, rangeTo){
            self.dateRange.date_from = rangeFrom;
            self.dateRange.date_to = rangeTo;
            self.simpleCalendarOptions.render && self.simpleCalendarOptions.render();
        };

        self.dateRange = {};
        self.dateRanges = [
            PERIODS.TODAY,
            PERIODS.THIS_WEEK,
            PERIODS.LAST_WEEK,
            PERIODS.THIS_MONTH,
            PERIODS.LAST_MONTH,
            PERIODS.LAST_3_MONTH,
            PERIODS.LAST_6_MONTH,
            PERIODS.LAST_12_MONTH
        ];

        self.selectDateRange = function(dr){
            unSelectDateRanges();
            dr.selected = true;
            self.selectedDateRange = dr;
            var range = getSelectedDateRange(dr.key);
            setRangeDates(range.from, range.to);
        };

        self.applyRange = function () {
            self.onRangeApplied({
                range: self.selectedDateRange,
                from: self.dateRange.date_from,
                to: self.dateRange.date_to
            });
        };

        self.clearRange = function () {
            setRangeDates(null, null);
            unSelectDateRanges();
            if (self.rangeFrom && self.rangeTo) {
                self.onRangeApplied({
                    range: null,
                    from: null,
                    to: null
                });
            }
        };

        self.simpleCalendarOptions = {
            monthsPerView: 2,
            mode: 'RANGE'
        };

        self.onDateRangeChanged = function () {
            unSelectDateRanges();
        };

        self.initDatesAndPeriod = function(){
            if(isValidRangeDate(self.rangeTo) && isValidRangeDate(self.rangeFrom)){
                if(self.rangeFrom.isAfter(self.rangeTo, 'day')){
                    setRangeDates(null, null);
                    console.error('hDateRangePickerComponent: from date should same or before to date');
                }else{
                    setRangeDates(self.rangeFrom, self.rangeTo);
                }
            }else if(isValidPeriod()){
                self.selectDateRange(PERIODS[self.period.toUpperCase()]);

            }
        };

        const prepareDateRangesMap = (dateRanges) => {
            const dateRangesMap = {};

            for (let range of dateRanges) {
                const selectedDateRange = getSelectedDateRange(range.key);
                dateRangesMap[range.key] = {
                    from: selectedDateRange.from.format('YYYY-MM-DD'),
                    to: selectedDateRange.to.format('YYYY-MM-DD')
                };
            }

            return dateRangesMap;
        };

        const setActiveRangePeriod = (dateRangesMap, rangeFrom, rangeTo) => {
            if (!rangeFrom || !rangeTo) {
                return;
            }
            const rangeFromDate = rangeFrom.format('YYYY-MM-DD');
            const rangeToDate = rangeTo.format('YYYY-MM-DD');

            for (let i in dateRangesMap) {
                const range = dateRangesMap[i];

                if (range.from === rangeFromDate && range.to === rangeToDate) {
                    const dateRangeIndex = self.dateRanges.findIndex((dateRange) => dateRange.key === i);
                    self.selectDateRange(self.dateRanges[dateRangeIndex]);
                    return;
                }
            }
        };

        self.$onInit = () => {
            self.initDatesAndPeriod();
            const dateRangesMap = prepareDateRangesMap(self.dateRanges);
            setActiveRangePeriod(dateRangesMap, self.rangeFrom, self.rangeTo);
        };

        self.$onChanges = function(changesObj){

            if (changesObj.minDate &&
                changesObj.minDate.currentValue !== changesObj.minDate.previousValue) {
                self.simpleCalendarOptions.min = self.minDate;
            }
            if (changesObj.maxDate &&
                changesObj.maxDate.currentValue !== changesObj.maxDate.previousValue) {
                self.simpleCalendarOptions.max = self.maxDate;
            }
            if(changesObj.period || changesObj.rangeFrom || changesObj.rangeTo){
                if(isValidRangeDate(self.rangeTo) && isValidRangeDate(self.rangeFrom) && self.rangeFrom.isAfter(self.rangeTo, 'day')){
                    setRangeDates(null, null);
                    console.error('hDateRangePickerComponent: from date should same or before to date');
                }else{
                    setRangeDates(self.rangeFrom, self.rangeTo);
                }
            }
        };
    }

})();
